export default "<h1 data-translate=\"error.page_not_found\">{{'error.page_not_found' | translate:'Page not found.'}}</h1>";